<template>
  <div class="register">
    <div class="login-content">
      <div class="logo"><router-link to="/" title="返回首页"><img src="../assets/logo1.png" height="72" width="680"/></router-link></div>
      <div class="login-advertising"><img src="../assets/img/register-1.jpg"></div>
      <div class="login-section">
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm"  label-position="top" class="demo-ruleForm" :inline="true">
          <el-divider>注册信息</el-divider>
          <el-form-item label="账号名" prop="userName" style="width: 260px">
            <el-input v-model="ruleForm.userName" placeholder="账户名为3-20位的字符"></el-input>
          </el-form-item>
          <el-form-item prop="phone" label="手机号" style="width: 260px">
            <el-input v-model="ruleForm.phone" placeholder="请输入手机号" @input="istruevcode(ruleForm.phone)"></el-input>
          </el-form-item><br>
          <el-form-item label="密码" prop="pass" style="width: 260px">
            <el-input type="password" v-model="ruleForm.pass" placeholder="密码" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item prop="vcode" label="验证码" style="width: 260px">
            <div class="bind_code">
              <el-input class="bind_code_input code" v-model="ruleForm.vcode" maxlength="16" placeholder="短信验证码"/>
              <el-button @click.native.prevent="bindforgetSendCode" class="codebtn" :disabled="disabled">{{btnText}}</el-button>
            </div>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPass" style="width: 260px">
            <el-input type="password" v-model="ruleForm.checkPass" placeholder="确认密码" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item prop="email" label="邮箱" style="width: 260px">
            <el-input v-model="ruleForm.email" placeholder="常用邮箱"></el-input>
          </el-form-item>
          <el-divider>公司信息</el-divider>
          <el-form-item label="企业名称" style="width: 260px">
            <el-input v-model="ruleForm.company"></el-input>
          </el-form-item>
          <el-form-item label="企业地址" style="width: 260px">
            <el-input v-model="ruleForm.address"></el-input>
          </el-form-item><br>
          <p class="text-container">点击“注册”，即表示您同意上述内容及<a>帐号用户协议</a>、 关于<a>帐号与隐私的声明</a>。</p>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')" style="width: 120px" :disabled="disableds">注 册</el-button>
            <el-button @click="resetForm('ruleForm')">重 置</el-button>
          </el-form-item>
        </el-form>
        <span class="reg-login-link">已有帐号，<a @click="gologin">去登录</a><em class="right-arrow"></em></span>
      </div>
    </div>
    <p class="copyright">© {{ new Date().getFullYear() }} 浙江萧山化学纤维产业大脑有限公司版权所有&nbsp;&nbsp;v{{version}} &nbsp;&nbsp; 备案号：<a href="http://beian.miit.gov.cn/" target="_blank">
      {{ recordicp }}</a><img
      src="../assets/home/ba.png" height="22" width="20" style="vertical-align: sub; margin-left: 12px"/><a :href="'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode='+recordpublic" rel="noopener" target="_blank"> 公网备案：{{ recordpublic }}</a></p>
  </div>
</template>
<script>
import {insertStr} from "../bll/utils";

export default {
  name: 'Register',
  data () {
    var checkAge = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('年龄不能为空'))
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error('请输入数字值'))
        } else {
          if (value < 18) {
            callback(new Error('必须年满18岁'))
          } else {
            callback()
          }
        }
      }, 1000)
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        const szzf = /(?!^[0-9]+$)(?!^[a-z]+$)(?!^[A-Z]+$)(?!^[^A-z0-9]+$)^[^\s\u4e00-\u9fa5]{6,}/
        if (!szzf.test(value)) {
          return callback(new Error('必须有大小写字母、字符和数字两种以上'))
        }
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    var validateyhzh = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入账户名'))
      }
      const yhzhreg = /^[a-z][a-z\d_]{2,19}$/
      if (!yhzhreg.test(value)) {
        callback(new Error('不能是下划线和数字开头，不能有大写字母'))
      } else {

        const url = '/api-portal/account/checkName';
        this.$api.get(url, {zh:value}, (response) => {
          let datas=response.data||''
          if(datas.code=='000000'){
            callback()
          }else {
            callback(new Error(datas.message||'账号已存在请重新输入'))
          }
        },'json')
      }
    }
    var checkIDCard = (rule, value, callback) => {
      const IDCardReg = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[0-2])(([0-2][1-9])|10|20|30|31)\d{3}(\d|X|x)$/
      if (value) {
        if (IDCardReg.test(value)) {
          callback()
        } else {
          callback(new Error('身份证号格式不正确'))
        }
      } else {
        callback(new Error('请输入身份证号'))
      }
    }
    var phones = (rule, value, callback) => {
      if (!value) {
        this.disabled=true
        callback(new Error('手机号不能为空'))
      } else {
        const reg = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/
        if (reg.test(value)) {
          this.disabled=false
          callback()
        } else {
          this.disabled=true
          return callback(new Error('手机号格式不正确'))
        }
      }
    }
    return {
      ruleForm: {
        pass: '',
        checkPass: '',
        userName: '',
        age: '',
        email: '',
        phone: '',
        vcode: '',
        company: '',
        address: ''
      },
      rules: {
        pass: [
          { min: 6, message: '输入密码长度必须大于6位'},
          { validator: validatePass, trigger: 'blur', required: true}
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur', required: true }
        ],
        age: [
          { validator: checkAge, trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        phone: [
          { validator: phones, required: true, trigger: 'blur' }
        ],
        vcode: [
          { required: true, message: '验证码不能为空', trigger: 'blur' }
        ],
        userName: [
          { min: 3, message: '输入账号名长度必须大于3位'},
          { max: 20, message: '输入账号名长度必须小于20位'},
          { required: true, validator: validateyhzh, trigger: 'blur' }
        ]
      },
      disabled: true,
      disableds: false,
      btnText: '获取验证码',
      version:this.$versionclient,
      recordicp:process.env.RECORD=='production'?'浙ICP备2022025995号':'浙ICP备2022025995号-2',
      recordpublic:process.env.RECORD=='production'?'33010902003449':'33010902003449'
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    submitForm (formName) {
      let $this=this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            address:$this.ruleForm.address,
            company:$this.ruleForm.company,
            email:$this.ruleForm.email,
            qryhmm:this.$md5(insertStr($this.ruleForm.checkPass)),
            sjhm:$this.ruleForm.phone,
            yhmm:this.$md5(insertStr($this.ruleForm.pass)),
            yzm:$this.ruleForm.vcode,
            zh:$this.ruleForm.userName
          }
          const url = '/api-portal/account/registerPortal';
          this.$api.post(url, data, (response) => {
            let datas=response.data||''
            console.log('datas',datas)
            if(datas.code=='000000'){
              this.$message({
                message: '注册成功，去登录吧',
                type: 'success'
              });
              $this.resetForm('ruleForm')
              $this.ruleForm.company=''
              $this.ruleForm.address=''
              $this.ruleForm.phone = ''
              $this.$router.replace('/login')
            }else {
              // this.$message({
              //   message: datas.message||'注册失败，请稍后再试',
              //   type: 'warning'
              // });
            }
          },'json');
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    bindforgetSendCode () {
      let $this=this
      this.$refs['ruleForm'].validateField('phone', (errorMessage) => {
        console.log(errorMessage)
        if (!errorMessage) {
          const url = '/api-portal/account/message';
          this.$api.get(url, {sjhm:$this.ruleForm.phone}, (response) => {
            let datas=response.data||''
            if(datas.code=='000000'){
              this.$message({
                message: '验证码已发送',
                type: 'success'
              })
              this.disabled = true
              this.btnText = '请稍候...'
              setTimeout(() => {
                this.doLoop(60)
              }, 500)
            }
          },'json')
        } else {
          return false
        }
      })
    },
    doLoop: function (seconds) {
      seconds = seconds || 60
      this.btnText = seconds + 's后获取'
      let countdown = setInterval(() => {
        if (seconds > 0) {
          this.btnText = seconds + 's后获取'
          --seconds
        } else {
          this.btnText = '获取验证码'
          this.disabled = false
          clearInterval(countdown)
        }
      }, 1000)
    },
    istruevcode(v){
      if(v.length==11){
        this.$refs['ruleForm'].validateField('phone', (errorMessage) => {
          if (!errorMessage) {
            this.disabled = false
          }else {
            this.disabled = true
          }
        })
      }
    },
    isgoing(){
      this.$refs['ruleForm'].validate((valid) => {
        if(valid){
          this.disableds = false
        }else {
          this.disableds = true
        }
      })
    },
    gologin(){
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.register{
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  background: url("../assets/login-bj.jpg") no-repeat center center;
  justify-content: center;
  align-items: center;
}

.copyright{
  position: fixed;
  left: 0;
  bottom: 10px;
  width: 100%;
  text-align: center;
  font-size: 16px;
  color: #fff;
}

.copyright a{
  color: #fff;
}
.copyright a:hover{
  color: yellow;
}

.login-content{
  width: 1042px;
  height: 514px;
  background: rgba(99,175,245,.85);
  border-radius: 17px;
  display: flex;
  box-shadow: 3px 16px 13px rgba(0,0,0,.54);
  position: relative;
}

.logo{
  position: absolute;
  left: 0;
  top: -85px;
  width: 100%;
  text-align: center;
}

.login-advertising{
  flex: 1;
  height: 100%;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  overflow: hidden;
}

.login-section{
  width: 671px;
  box-sizing: border-box;
  padding: 20px 30px;
  border-top-right-radius: 19px;
  border-bottom-right-radius: 19px;
  background: rgba(255,255,255,.85);
}

  .demo-ruleForm{
    display: flex;
    justify-content: center;
    flex-wrap:wrap;
  }

  .bind_code{
    width: 100%;
    position: relative;
  }

  .codebtn{
    border: 0;
    background: none;
    padding: 0;
    border-radius: 0;
    position: absolute;
    top: 15px;
    right: 15px;
    color: #1b2dd1;
    padding-left: 10px;
    border-left: 1px solid #1b2dd1;
  }

  .codebtn.is-disabled{
    color: #C0C4CC;
  }

  .reg-login-link{
    position: absolute;
    bottom: 32px;
    left: 126px;
    font-size: 14px;
    color: #CED6F0;
  }

  .reg-login-link a{
    color: #fff;
    cursor: pointer;
    text-decoration: none;
    margin-right: 4px;
  }

  .text-container{
    font-size: 13px;
    width: 100%;
    text-align: center;
    margin-bottom: 12px;
    background-color: #ecf5ff;
    padding: 4px 12px;
  }

  .text-container a{
    color: #409eff;
    cursor: pointer;
    text-decoration: none;
  }

  .text-container a:hover{
    color: #2F489E
  }

</style>

<style>
  .login-section .el-form--label-top .el-form-item__label{
    padding: 0;
    line-height:32px;
  }
  .login-section .el-divider__text{
    background: none;
  }
  .login-section .el-divider--horizontal{
    margin-top: 10px;
    margin-bottom: 16px;
  }
  .login-section .el-form-item{
    margin-bottom: 12px;
  }
  .bind_code .el-input__suffix{
    right: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/views/register.vue